import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Gift, Heart, Sparkles, Home } from "lucide-react";
import ShareButtons from "@/components/ShareButtons";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const ThankYou = () => {
  const navigate = useNavigate();
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    setTimeout(() => setShowConfetti(false), 3000);
  }, []);

  localStorage.setItem('giftmap_profile_complete', 'true');
  return (
    <div className="min-h-screen bg-gradient-warm flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated background elements */}
      {showConfetti && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `-10%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
            >
              <Heart
                className="text-primary opacity-20"
                style={{
                  width: `${20 + Math.random() * 20}px`,
                  height: `${20 + Math.random() * 20}px`,
                }}
              />
            </div>
          ))}
        </div>
      )}

      <div className="w-full max-w-md space-y-6 relative z-10">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/30 blur-3xl rounded-full animate-pulse-soft" />
            <div className="relative bg-gradient-sunset p-8 rounded-full shadow-warm animate-float">
              <Gift className="w-16 h-16 text-white" />
            </div>
          </div>
        </div>

        {/* Success Message */}
        <Card className="p-8 text-center space-y-4 shadow-warm border-border/50">
          <div className="flex justify-center">
            <Sparkles className="w-8 h-8 text-accent animate-pulse" />
          </div>
          
          <h1 className="text-3xl font-bold bg-gradient-sunset bg-clip-text text-transparent">
            Gift Sent! 🎉
          </h1>
          
          <p className="text-lg text-muted-foreground">
            Your kindness just made someone's day brighter
          </p>

          <div className="pt-4 space-y-3">
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Heart className="w-4 h-4 text-secondary" />
              <span>Your gift will arrive within minutes</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Sparkles className="w-4 h-4 text-accent" />
              <span>They'll receive your personal message too</span>
            </div>
          </div>
        </Card>

        {/* Impact Card */}
        <Card className="p-6 bg-gradient-sunset/10 border-primary/20 shadow-soft">
          <div className="text-center space-y-2">
            <h3 className="font-semibold text-foreground">Your Impact</h3>
            <p className="text-sm text-muted-foreground">
              You've now sent joy to people nearby. Keep spreading kindness!
            </p>
            <div className="flex justify-center gap-6 pt-2">
              <div>
                <div className="text-2xl font-bold text-primary">1</div>
                <div className="text-xs text-muted-foreground">Gifts Sent</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-secondary">1</div>
                <div className="text-xs text-muted-foreground">Hearts Touched</div>
              </div>
            </div>
          </div>
        </Card>

        {/* Share Card */}
        <Card className="p-6 text-center space-y-4 shadow-soft">
          <h3 className="font-semibold text-foreground">Tell the world!</h3>
          <p className="text-sm text-muted-foreground">
            Inspire others to spread kindness too
          </p>
          <ShareButtons type="sent" />
        </Card>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            className="w-full bg-primary hover:bg-primary/90 shadow-soft"
            size="lg"
            onClick={() => navigate("/map")}
          >
            <Gift className="w-5 h-5 mr-2" />
            Send Another Gift
          </Button>
          <Button
            variant="outline"
            className="w-full border-border/50"
            onClick={() => navigate("/dashboard")}
          >
            <Home className="w-5 h-5 mr-2" />
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;